var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87164 13C2.53488 13 2.24984 12.8833 2.0165 12.65C1.78317 12.4167 1.6665 12.1316 1.6665 11.7949V4.20516C1.6665 3.86841 1.78317 3.58336 2.0165 3.35003C2.24984 3.1167 2.53488 3.00003 2.87164 3.00003H13.128C13.4648 3.00003 13.7498 3.1167 13.9831 3.35003C14.2165 3.58336 14.3331 3.86841 14.3331 4.20516V11.7949C14.3331 12.1316 14.2165 12.4167 13.9831 12.65C13.7498 12.8833 13.4648 13 13.128 13H2.87164ZM13.3332 4.96153L8.32417 8.16795C8.27289 8.197 8.2199 8.21986 8.1652 8.23653C8.1105 8.2532 8.05538 8.26153 7.99982 8.26153C7.94426 8.26153 7.88914 8.2532 7.83444 8.23653C7.77974 8.21986 7.72675 8.197 7.67547 8.16795L2.66649 4.96153V11.7949C2.66649 11.8547 2.68572 11.9038 2.72419 11.9423C2.76265 11.9808 2.8118 12 2.87164 12H13.128C13.1878 12 13.237 11.9808 13.2755 11.9423C13.3139 11.9038 13.3332 11.8547 13.3332 11.7949V4.96153ZM7.99982 7.33335L13.2306 4.00001H2.76905L7.99982 7.33335ZM2.66649 5.11536V4.35321V4.37308V4.35193V5.11536Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailThin);
export default __webpack_public_path__ + "static/media/EmailThin.1192bde942b88438c53776dc0578d520.svg";
export { ForwardRef as ReactComponent };